var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 17595",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 202",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M9.257 0v18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 203",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M18 8.743H0"
  })));
}

export default __webpack_public_path__ + "ddbcf0f5e22a0f533acde0a7304df918.svg";
export { SvgPlus as ReactComponent };